import React, { useMemo } from 'react';
import FadeIn from './FadeIn';
import { INSTALLATION_SHOTS } from '../../assets/installationShots';

function PhotoTile({ src, alt, caption, delay = 0 }) {
  return (
    <FadeIn delay={delay}>
      <figure className="rounded-xl overflow-hidden bg-slate-100 group">
        <div className="aspect-[4/3] overflow-hidden">
          <img
            src={src}
            alt={alt}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        {caption && (
          <figcaption className="px-3 py-2 text-xs font-medium text-slate-600 bg-white border-t border-invert-border">
            {caption}
          </figcaption>
        )}
      </figure>
    </FadeIn>
  );
}

export default function ProofPhotoWall({ apiScreens = [] }) {
  const photos = useMemo(() => {
    const staticPhotos = INSTALLATION_SHOTS.map((shot, i) => ({
      key: `static-${i}`,
      src: shot.src,
      alt: shot.alt,
      caption: null,
    }));

    const apiPhotos = (apiScreens || [])
      .filter((s) => s.listingPhotoUrl)
      .map((s) => ({
        key: `api-${s.screenId}`,
        src: s.listingPhotoUrl,
        alt: `INVERT screen at ${s.brand || `Screen ${s.screenId}`}`,
        caption: s.brand || null,
      }));

    const seen = new Set();
    const merged = [];

    [...staticPhotos, ...apiPhotos].forEach((photo) => {
      if (seen.has(photo.src)) return;
      seen.add(photo.src);
      merged.push(photo);
    });

    return merged;
  }, [apiScreens]);

  if (photos.length === 0) return null;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {photos.map((photo, i) => (
        <PhotoTile
          key={photo.key}
          src={photo.src}
          alt={photo.alt}
          caption={photo.caption}
          delay={i * 0.04}
        />
      ))}
    </div>
  );
}
